import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import DefaultImage from "./../Nano/DefaultImage.js";
import defaultSvg from "../../images/defaultCard.svg";
import PerformanceColor from "./PerformanceColor";
import NanoFlex from "../Global/NanoFlex";

//IMAGES
import { ReactComponent as Check } from "../Global/Icons/check.svg";
import { ReactComponent as NotaSelection } from "../Global/Icons/notaSelection-simple.svg";
import { ReactComponent as New } from "../Global/Icons/new.svg";

const multiple = nota.global.multiple;

const StyledImage = styled.div`
  width: 100%;
  height: 100%;
  .loader {
    width: 100%;
    background-color: ${nota.color.neutral.NeuThree};
    overflow: hidden;
    position: relative;
    padding-bottom: calc(591.44 / 1127.34 * 100%);
  }

  .imgWrapper {
    display: ${(props) => (props.isLoading ? "none" : "block")};
    width: ${(props) => (props.isLoading ? "0%" : "100%")};
    overflow: hidden;
    position: relative;
    background-color: ${nota.color.neutral.NeuThree};
    padding-bottom: calc(591.44 / 1127.34 * 100%);
    img {
      width: ${(props) => (props.isLoading ? "0%" : "100%")};
      height: ${(props) => (props.isLoading ? "0%" : "100%")};
      position: absolute;
      object-fit: cover;
    }
    .performanceWrapper {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 1;
      svg {
        vertical-align: bottom;
      }
    }

    .selectThumbContainer {
      display: ${(props) => (props.selectable ? "block" : "none")};
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      .selectThumb {
        padding: ${multiple / 2 + "px"};
        background: ${nota.color.neutral.NeuFour};
        width: 35px;
        height: 100%;
        svg {
          path {
            fill: ${nota.color.neutral.NeuTwo};
          }
        }
      }
      .selectedThumb {
        background-color: ${nota.color.main.default};
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }

    .notaSelectionWrapper {
      display: block;
      position: absolute;
      top: 0;
      right: ${multiple / 2 + "px"};
      z-index: 1;
      svg {
        height: 24px;
        width: auto;
      }
    }
    .newLabelWrapper {
      display: block;
      position: absolute;
      z-index: 0;
      top: 0;
      right: ${(props) => (props.isNotaSelection ? "26px" : "4px")};
      .newLabel {
        background-color: ${nota.color.neutral.NeuFive};
        padding: 6px;
        width: auto;
        border-radius: 0 0 10px 10px;
        box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
        svg {
          height: 8px;
          width: auto;
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
    }
  }
`;

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.imageUrl !== this.props.imageUrl) {
      this.setState({ isLoading: false, error: false });
    }

    if (prevState.error !== this.state.error && this.props.onError) {
      this.props.onError(this.state.error);
    }
  }

  handleImageLoaded = () => {
    this.setState({ isLoading: false });
  };

  handleImageErrored = () => {
    this.setState({ error: true, isLoading: false });
  };

  render() {
    return (
      <StyledImage isLoading={this.state.isLoading} width={this.props.width} height={this.props.height} selectable={this.props.selectable} isNotaSelection={this.props.isNotaSelection} isNew={this.props.isNew}>
        {this.props.placeholder && <div className="loader" />}
        {this.state.isLoading && !this.state.error && !this.props.placeholder && <div className="loader" />}
        {!this.props.placeholder && (
          <div className="imgWrapper">
            <img src={this.state.error ? defaultSvg : this.props.imageUrl} alt={this.props.alt} onLoad={this.handleImageLoaded} onError={this.handleImageErrored} />
            {this.props.performanceColor && (
              <div className="performanceWrapper">
                <PerformanceColor color={this.props.performanceColor} />
              </div>
            )}
            {!this.props.hideSelection && (
              <div
                className="selectThumbContainer"
                onClick={(e) => {
                  if (this.props.onSelectClick) {
                    this.props.onSelectClick(e);
                  }
                }}>
                <NanoFlex className={`selectThumb ${this.props.selected ? "selectedThumb" : ""}`}>
                  <Check />
                </NanoFlex>
              </div>
            )}
            {this.props.isNotaSelection && (
              <div className="notaSelectionWrapper">
                <NotaSelection />
              </div>
            )}
            {this.props.isNew && (
              <div className="newLabelWrapper">
                <NanoFlex className="newLabel">
                  <New />
                </NanoFlex>
              </div>
            )}
          </div>
        )}
      </StyledImage>
    );
  }
}

// Set default props
Image.defaultProps = {
  placeholder: false,
  performanceColor: null,
};

export default Image;

// --- // Documentation // --- //
/*
import Image from './../Nano/Image.js';

<Image
  imageUrl={''}
  alt={''}
  size={'xxs'}
  performanceColor={null}
/>
*/
